import { render, staticRenderFns } from "./farmDetail.vue?vue&type=template&id=09f52d64&scoped=true&"
import script from "./farmDetail.vue?vue&type=script&lang=js&"
export * from "./farmDetail.vue?vue&type=script&lang=js&"
import style0 from "./farmDetail.vue?vue&type=style&index=0&id=09f52d64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f52d64",
  null
  
)

export default component.exports